// extracted by mini-css-extract-plugin
export default {"container":"g_dwZT","iconWrapper":"KE7eI5"};